/*!jslint
  this
*/
jQuery(function($) {
  "use strict";
  //Preload
  // $(window).on('load', function(){
    var urlParams = new URLSearchParams(window.location.search);
    var edm = urlParams.get('edm');
    // console.log(edm)
    if($('body').hasClass('home') || $('body').hasClass('single-newsletter')){
      if(edm == 'true') {
        $('.pre-loader').hide();
      } else {
        setTimeout(function() {
          $('.pre-loader').fadeOut();
          $('body').addClass('loaded');          
        }, 2800);
      }
    }
  // });

  //Youtube

  if ($('.nw-video').length) {
    $('.nw-video').magnificPopup({
      type:'iframe',
      midClick: true
    });
  }


  //News Slider
  if ($('.accordion-slider').length) {
    $('.accordion-slider').slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll:1,
      autoplay: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });

    $('#newsblock').on('show.bs.collapse', function (e) {
        $('.accordion-slider').slick('unslick');
        $('.accordion-slider').slick({
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll:1,
          autoplay: true,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear'
        });
    });
  }
  //AOS 
  AOS.init();

  //Media
  // if ($('.me-block').length) {
  //   $('.me-block').slick({
  //     dots: false,
  //     arrows: false,
  //     slidesToShow: 1,
  //     slidesToScroll:1,
  //     // autoplay: true,
  //     infinite: false,
  //     // speed: 500,
  //     touchMove: true,
  //     // vertical: true,
  //     // verticalSwiping: true,
  //    fade: true,
  //     cssEase: 'linear'
  //     // useTransform: true,
  //     // cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  //     // adaptiveHeight: true,
  //   });

  //   //Implementing navigation of slides using mouse scroll
  //   const slider = $(".me-block");
  //   slider.on('wheel', (function(e) {
  //     e.preventDefault();
  //       if (e.originalEvent.deltaY < 0) {
  //         $(this).slick('slickPrev');
  //       } else {
  //         $(this).slick('slickNext');
  //       }
  //       }));
  //     }

  $(window).on('scroll', function(e){
    if($('.product-features-section').length){
      var ST = $(this).scrollTop();
      var OT = $('.product-features-section').offset().top;
      var PH = $('.product-features-section').outerHeight();
      var IH = $('.product-features-sticky-item').outerHeight();
      var WH = $(this).outerHeight();
      if(ST>=OT-90){
        if(ST>OT-90 && ST<OT+PH-IH-90){
          $('.product-features-sticky').addClass('sticky').css('top', '90px');
          
        }else{
          $('.product-features-sticky').removeClass('sticky').css('top', PH-IH);
        }				
      }else{
        $('.product-features-sticky').removeClass('sticky').css('top', '0');
      }
      $('.product-features-item').each(function(i){
        var OTN = $(this).offset().top;
        var IHN = $(this).outerHeight();
        var OBN = OTN+IHN;
        var offset = 350;
        var item = $(this).data('img');
        if(ST>=OT-90){
          if(ST>OTN-offset && ST<OBN-offset){
            $('.product-features-sticky-item').removeClass('active');
            $(item).addClass('active');
            // console.log(ST+'  -  '+(OTN-offset)+'  -  '+(OBN-offset));
            // console.log(item);
          }
        }else{
          /*$('.product-features-sticky-item').removeClass('active');
          $('.product-features-sticky-item').first().addClass('active');*/
        }
      });
    }
  });

    //Team
    if ($('.te-team').length) {
      $(document).on('click', '.te-team', function(e){
       $(this).toggleClass('active');

       const $blockID = $(this).attr('data-block');
        if($('.te-team').hasClass('active')) {
          $('.te-team').not(this).removeClass('active');
        }
        $('.te-team-int').removeClass('active');
      });

      $(document).on('click', '.entire', function(e){
        $(this).parent().parent().parent().toggleClass('active');

        $('.te-team-int').removeClass('active');
        const $inID = $(this).attr('data-interview');
        setTimeout(function(){
          
          if( $('[data-block="'+$inID+'"]').hasClass('active')) {
            $('[data-block="'+$inID+'"]').removeClass('active');
          } else {
            $('[data-block="'+$inID+'"]').addClass('active');

          }
        }, 200);

      });
    }

    //Sscrool menu
    if ($('.side-menu').length) {
      $(document).on('click', '#btn-menu', function(e){
 
          $('.side-menu').toggleClass('active');
          $('body').toggleClass('menu-active');
      });
      $(document).on('click', '#menu-col li a', function(e){
        $('.side-menu').removeClass('active');
        $('body').removeClass('menu-active');
    });

    var container = $("#menu-col");
    var menuItem = $("#menu-col a");
    var btnItem = $("#btn-menu");
      $(document).mouseup(function (e) {
        if ($('.side-menu').hasClass('active')) {
          if (!container.is(e.target) && container.has(e.target).length === 0 && !menuItem.is(e.target) && !btnItem.is(e.target) && btnItem.has(e.target).length === 0) {
            $('body').removeClass('menu-active');
            $('.side-menu').removeClass('active');
          }
        }
      });
    }


    // Popup
    $('.pop').magnificPopup({
      type:'inline',
      midClick: true 
    });
    $(document).on('click', '.pop', function () {
        const project = $(this).attr('data-project');
        //console.log(project);
        $("#field_2_8 select").val(project).change();;
    });

  //   $(document).on('click', '.pop', function () {
  //     const project = $(this).attr('data-project');
  //     c//onsole.log(project);
  //     $("#field_2_8 select").val(project).change();;
  // });

  //Scroll to position
  if ($('.cs-block').length) {
    $(function() {
      var block = $('.cs-block');
      var hieghtThreshold = $(".cs-block").offset().top - 500;
      //console.log(hieghtThreshold);
      var hieghtThreshold_end  = $(".cs-block").offset().top +$(".cs-block").height() ;
      $(window).on('scroll', function () {
          var scroll = $(window).scrollTop();

          if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
            block.addClass('active');
          } else {
            block.removeClass('active');
          }
      });
    })
  }

    //Load more
    $(document).on('click', '.loadmore', function (e) {
      e.preventDefault();
      var $el = $(this),
        $tgt = $el.data('target'),
        link = $el.attr('href');
      if ($el.attr('disabled'))
        return;
      $el.addClass('loading').attr('disabled', true);
      $el.find('span').html('Loading...')
      $("<div>").load(link + $tgt, function () {
        $($tgt).append($(this).find($tgt).html());
        $el.parents('.load-more').removeAttr('disabled').remove();
      });
    });
    $(window).on("scroll", function () {
      if ($('.load-more').length) {
        var TopPos = $('.load-more').offset().top;
        var ST = $(this).scrollTop();
        var FH = $(this).outerHeight();
        if (ST + FH >= TopPos - 300) {
          $('.loadmore').trigger('click');
        }
      }
    });

//salesforce

$(document).on('change', '.project-selector-c select', function(e){
  var $val = salesforce_project_id ($(this).val());
  $('.sf-project-id-c input').val($val);
});
$(document).on('change', '.project-selector-p select', function(e){
      var $val = salesforce_project_id ($(this).val());
      $('.sf-project-id-p input').val($val);
});

function salesforce_project_id (item){
  var $val = '1036585081';
    if( item == 'Balfour Place, Lindfield (AU)'){
      $val = '561348012';
    }else if(item == 'Paragon (AU)'){
      $val = '1078027898';
    }else if(item == 'Dairy Farmers Towers (AU)'){
      $val = '793581607';
    }else if(item == 'The Merewether Residences (AU)'){
      $val = '270806567';
    }else if(item == 'Kurraba (AU)'){
      $val = '2033460725';
    }else if(item == 'Graphite Square (UK)'){
      $val = '2001304135';
    }else if(item == 'Precinct 21'){
      $val = '996214544';
    }

    return $val;
}

//Wrap js
  if ($('.wr-box').length) {
    $(document).on('click', '.wr-box-main-top', function(e){
    if($('.wr-box').hasClass('active')) {
        $('.wr-box').not($(this).parent().parent()).removeClass('active');
    }
    $(this).parent().parent().toggleClass('active')
    });
  }
});
